<template>
<div>
	<Window ref="Window" :bg="Boolean(true)" @Close='deviceControlClose'>
		<!-- 头部开始 -->
		<div slot="headButton" class="dpIB fSub_E hover-f-main_E tra-fast_E">
			<button :title="$t('cmd7',['刷新'])" @click="refresh" type="button">
				<Icon name="refresh" class="w1x h1x" :sizeBase="'m'" /></button>
		</div>
		<div slot="head" class="cb">
			<div class="">
				<div>
					<div class="dpIB vaM fs14x">{{getTypeText(deviceDetail.type||'','deviceType')+':'}}{{deviceDetail.deviceSn}}</div>
				</div>
				<div class="posR mt1x">
					<div class="dpIB dpIB_E">
						<div class="mr1x vaM_E">
							<span v-if="deviceDetail.deviceState==null">--</span>
							<StatusIco v-else :id="deviceDetail.deviceState" :type="'device'" class="statueIcon"></StatusIco>
							<span v-if="deviceDetail.deviceState!=null" class="dpIB">
								{{getTypeText(deviceDetail.deviceState,'deviceState')}}
							</span>
						</div>
						<!-- <div class="mr1x vaM_E">
							<span v-if="deviceDetail.alertStatus==null">--</span>
							<StatusIco v-else :id="deviceDetail.alertStatus" :type="'deviceAlarm'" class="statueIcon"></StatusIco>
							<span v-if="deviceDetail.alertStatus!=null">
								{{[-1].includes(deviceDetail.alertStatus)?getLanguageStr('word1465','无报警'):getLanguageStr('word1464','有报警')}}
							</span>
						</div> -->
					</div>
					<div class="fR">
						<span v-if="deviceDetail.collectionTime">{{timeFormat(deviceDetail.collectionTime,'utc','%Y/%m/%d %H:%M:%S UTC',{offset:deviceDetail.timeZone})}}</span>
					</div>
				</div>
			</div>
		</div>
		<!-- 头部结束end -->
		<div class="navBtn pl1x bdSub-bottom-notLast">
			<div class="tabBar style-tabBar cb active-c-main_E tra-fast_E">
				<button v-for="(item,index) in btnGroup" v-show="item.isShow" @click="curTabChange(index)" :key="index" class="cSub afterButton" :class="{'active':curTab==index}">{{item.title}}</button>
			</div>
		</div>
		<div fillheight="lastHeight,+space" class="pl1x pt1x pr1x pb1x" scroll>
			<BatchParam v-show="curTab == 0&&orderOption.batch" :classCode="orderOption.batch?orderOption.batch.group:''" :codeList="orderOption.batch?orderOption.batch.list:null" :device="device" ref="BatchParam" />
			<ParamControl ref="paramControl" :device="device" :deviceType="deviceType" v-show="curTab == 1"></ParamControl>
			<selfdefining-control ref="selfdefiningControl" :device="device" :deviceType="deviceType" v-show="curTab == 2"></selfdefining-control>
		</div>
	</Window>
</div>
</template>

<script>
import Window from '@/components/common/ui/WindowForView.vue'
import StatusIco from '@/components/common/ui/StatusIco'
import BatchParam from '@/view/device/device/part/BatchParam.vue' //批量指令
import SelfdefiningControl from '@/view/device/device/part/SelfdefiningControl.vue' // 自定义指令
import ParamControl from '@/view/device/device/part/ParamControl' // 参数指令
import { loadContralOption } from '@/util/deviceOrderConfig'
import { getLanguageStr } from '@/util/language'

import * as lib from '@/util/lib'

import { getDeviceDetail } from '@/api/device/list'
import {apiGetAvailableOrder} from '@/api/device/order'

export default {
	name: 'DeviceControl',
	components: { Window, StatusIco, SelfdefiningControl, ParamControl, BatchParam },
	data () {
		return {
			id: 'DeviceControl',
			device: {},
			deviceType: '',
			statusName: ['NORMAL', 'ALERTING'],
			btnGroup: [{
				title: getLanguageStr('device283', '批量参数'),
				ref: 'BatchParams',
				isShow: true
				// Perms: 'A/B/F'
			}, {
				title: getLanguageStr('word1500', '参数读写'),
				ref: 'ChildSys',
				isShow: true
				// Perms: 'A/B/F'
			}, {
				title: getLanguageStr('word1689', '自定义命令'),
				ref: 'Details',
				isShow: false
				// Perms: 'A/B/F'
			}],
			curTab: 0,
			codeList:{},
			orderOption:{},//可用指令总数据
			deviceDetail: {},
			instance: ''
		}
	},
	methods: {
		getLanguageStr,
		timeFormat: lib.timeFormat,
		getTypeText: lib.getTypeText,
		show (device, codeList, indexNow, instance) {
			if (instance) {
				this.instance = instance
			}
			this.codeList = codeList
			this.device = device
			this.curTab = indexNow || 0
			if (this.curTab == 2) {
				statistic('A69', 'A6901')
			} else {
				statistic('A69', 'A6903')
			}
			// for test
			//			this.device.deviceId = '200000012'
			//			this.device.deviceSn = 'DEIN202011600186'
			//			this.device.parDeviceId = '200000011'
			//			this.device.parDeviceSn = '501000001'
			if (codeList) {
				this.btnGroup[0].isShow=codeList.batch.isExist;
				this.btnGroup[1].isShow=codeList.single.length>0;
				this.btnGroup[2].isShow=codeList.customize;
			}
			this.$refs.Window.show({
				end:()=>{
					loadContralOption(() => {
						this.getDeviceInfo(codeList.single)
						this.getOpenStatus()
					});
				}
			});
		},
		refresh () {
			this.getDeviceInfo(this.codeList.single, true);
			this.getOpenStatus();
		},
		getDeviceInfo (singleList, isref) {
			getDeviceDetail({
				'siteId': this.device.siteId,
				'deviceId': this.device.deviceId,
				'language': stage.languageId,
				'needRealTimeDataFlag': true,
				'tag': 'version'
			}).then(res => {
				this.$refs.Window.loadStatusAction(false)
				// if (res) res.collectionTime = Number(res.collectionTime) + mz.tz(res.timeZone)._offset * 60
				this.deviceDetail = res
				//  console.log(this.deviceDetail)
				this.deviceType = res.type// lib.getTypeText("","deviceType",true)[0].id.includes(res.type)?1:2
				this.$nextTick(() => {
					if (!isref || isref == false) {
						this.$refs.selfdefiningControl.showLast();
					}
				})
				return res
			}, error => {
				this.$refs.Window.loadStatusAction(false)
				!_.isEmpty(error) && this.$notify(error)
				return false
			}).then(res => {
				if (res) {
					if (this.curTab == 0) {
						this.$refs.paramControl.show(singleList || '')
					}
				}
			})
		},
		deviceControlClose () {
			// this.curTab = 0// 默认打开显示第一个Tab
			this.$refs.selfdefiningControl.clear()// 清楚定时器
			if (this.instance) {
				setTimeout(() => {
					this.instance.destroyUi()
				}, 500)
			}
		},
		curTabChange (index) {
			this.curTab = index;
			if(index==0){
				this.$refs.BatchParam.reset();
			}
			if (index == 1) {
				statistic('A69', 'A6903')
				this.$refs.selfdefiningControl.clear()
				this.$refs.paramControl.show()
			} else {
				statistic('A69', 'A6901')
			}
		},
		getOpenStatus () {
			apiGetAvailableOrder(this.device.productId,this.device.deviceId).then(res => {
				// $.extend(true,res.batch,{
				// 	group:"G1101",
				// 	isExist:true,
				// 	list:["r_dcsz","s_dcsz"]
				// });
				this.orderOption=res;
				this.btnGroup[0].isShow=res.batch.isExist;
				this.btnGroup[1].isShow=res.single.length>0;
				this.btnGroup[2].isShow=res.customize;
				let targetTab=-1;
				if(this.btnGroup[0].isShow) targetTab=0;
				else if(this.btnGroup[1].isShow) targetTab=1;
				else if(this.btnGroup[2].isShow) targetTab=2;
				this.curTabChange(targetTab);
			});
		}

	},
	mounted () {
		setTimeout(() => {
			lib.fillHeight();
			lib.setScroll($(this.$el).find('[scroll]'));
		}, 500)
	}
}
</script>

<style lang="scss" scoped>
.window > .body {
	padding-bottom: 0;
}
.head {
	background: #fff;
}
button::-moz-focus-inner {
	border: 0;
}
.dropList {
	background: #fff;
	width: 9em;
	left: -2em;
	a {
		color: #666;
		padding-right: 1em;
	}
	a:hover {
		background-color: rgba(0, 0, 0, 0.05);
		color: #ff595f;
	}
}
.pd0 {
	padding: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/view/device/device/DeviceControl.vue